import * as React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    ReferenceField,
} from 'react-admin';
import TargetTitle from './TargetTitle';

const TargetShow = props => (
    <Show title={<TargetTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <ReferenceField label="Instances" source="instance_id" reference="instances">
                <TextField source="name" />
            </ReferenceField>
            <TextField source="name" />
            <TextField source="slug" />
            <TextField source="type" />
            <TextField source="account_name" />
            <TextField source="account_key" />
        </SimpleShowLayout>
    </Show>
);

export default TargetShow;